import PropTypes from "prop-types";
import React from "react";
import Form from "react-bootstrap/Form";

function Checkbox(props) {
  const { formik, name, type, checked, ...rest } = props;

  return (
    <Form.Check
      name={name}
      type={type}
      checked={checked}
      {...formik?.getFieldProps(name)}
      {...rest}
      onChange={(e) =>
        formik?.setFieldValue(
          name,
          type === "radio" ? e.target.value : e.target.checked
        )
      }
    />
  );
}

export const defaultProps = {
  className: "",
  label: "",
  type: "checkbox",
};

export const propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  onBlur: PropTypes.func,
  onMouseDown: PropTypes.func,
};

Checkbox.defaultProps = defaultProps;

Checkbox.propTypes = {
  ...propTypes,
  type: PropTypes.oneOf(["checkbox", "radio"]),
};

export default Checkbox;
